import { render, staticRenderFns } from "./PhotoManager.vue?vue&type=template&id=dfc36642&scoped=true&"
import script from "./PhotoManager.vue?vue&type=script&lang=js&"
export * from "./PhotoManager.vue?vue&type=script&lang=js&"
import style0 from "./PhotoManager.vue?vue&type=style&index=0&id=dfc36642&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc36642",
  null
  
)

export default component.exports